import React, { useEffect, useState, useContext, useRef } from "react";
import { ThemeContext } from "../../../App";
import Swal from "sweetalert2";
import axios from "axios";
import { GrUserAdmin } from "react-icons/gr";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Albums = ({ Ip }) => {
  const { isDark } = useContext(ThemeContext);
  const [data, setData] = useState([]);

  const [editData, setEditData] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [adminUsername, setAdminUsername] = useState("");
  const [access_role, setAccessRole] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedAdmin = localStorage.getItem("admin_info");
    const admin = storedAdmin ? JSON.parse(storedAdmin) : null;
    if (admin) {
      setAccessRole(Number(admin.accessLvl));
      setAdminUsername(admin.username);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const formData = new FormData();
      formData.append("action", "get");
      const res = await axios.post(
        `${Ip}/Dashboard/app_settings.php`,
        formData,
      );
      setData(res.data.data);
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  const handleEdit = (row) => {
    setEditData({ ...row, imageFile: null, audioFile: null });
    setShowModalEdit(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("action", "edit");
      formData.append("id", editData.id);

      if (adminUsername) {
        formData.append("admin", adminUsername);
      }

      if (editData.imageFile) {
        formData.append("image", editData.imageFile);
      }

      const res = await axios.post(
        `${Ip}/Dashboard/app_settings.php`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.data.success) {
        Swal.fire("Updated!", "Image updated successfully.", "success");

        fetchData();
        setShowModalEdit(false);
        setEditData(null);
      } else {
        Swal.fire("Error", res.data.message || "Update failed.", "error");
      }
    } catch (err) {
      console.log(err);
      Swal.fire("Error", "Something went wrong.", "error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="p-4">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold">Settings Images</h1>
          <p className="text-light-muted dark:text-dark-muted text-sm">
            Manage application images
          </p>
        </div>
      </div>

      <div className="overflow-x-auto rounded-lg border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface">
        <table className="min-w-full table-auto">
          <thead className="bg-light-surfaceSoft dark:bg-dark-surfaceSoft">
            <tr>
              <th className="px-4 py-3 text-left">Setting Key</th>
              <th className="px-4 py-3 text-left">Image</th>
              <th className="px-4 py-3 text-left">Last Modified By</th>
              <th className="px-4 py-3 text-left">Actions</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-light-border dark:divide-dark-border">
            {data
              .filter((item) => item.setting_key)
              .map((row) => (
                <tr
                  key={row.id}
                  className="hover:bg-light-surfaceSoft/50 dark:hover:bg-dark-surfaceSoft/50"
                >
                  <td className="px-4 py-3 font-medium">{row.setting_key}</td>

                  <td className="px-4 py-3">
                    <img
                      src={`${Ip}/${row.setting_value}`}
                      alt={row.setting_key}
                      className="w-20 h-20 rounded-lg object-cover border"
                    />
                  </td>

                  <td className="px-4 py-3 font-medium">{row.last_modified_by}</td>
                  <td className="px-4 py-3">
                    <button
                      onClick={() => {
                        setEditData({
                          ...row,
                          imageFile: null,
                        });
                        setShowModalEdit(true);
                      }}
                      className="px-3 py-1.5 rounded-md bg-light-brand hover:bg-light-brandHover dark:bg-dark-brand dark:hover:bg-dark-brandHover text-white text-sm"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {showModalEdit && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-light-surfaceSoft dark:bg-dark-surfaceSoft text-light-text dark:text-dark-text border border-light-border dark:border-dark-border p-6 rounded-xl w-full max-w-lg shadow-2xl">
            <h2 className="text-xl font-bold mb-5">Edit Image</h2>

            <div className="space-y-5">
              <label className="flex flex-col gap-2">
                <span className="font-semibold">Setting Key</span>

                <input
                  disabled
                  value={editData.setting_key}
                  className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 border"
                />
              </label>

              <label className="flex flex-col gap-2">
                <span className="font-semibold">Current Image</span>

                <img
                  src={`${Ip}/${editData.setting_value}`}
                  className="w-48 rounded-lg border"
                />
              </label>

              <label className="flex flex-col gap-2">
                <span className="font-semibold">Upload New Image</span>

                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      imageFile: e.target.files[0],
                    }))
                  }
                />
              </label>
            </div>

            <div className="flex justify-end gap-2 mt-6">
              <button
                onClick={() => setShowModalEdit(false)}
                className="px-4 py-2 rounded-lg border border-light-border dark:border-dark-border"
              >
                Cancel
              </button>

              {/* <button
                onClick={handleUpdate}
                disabled={loading}
                className="px-4 py-2 rounded-lg bg-light-brand hover:bg-light-brandHover dark:bg-dark-brand dark:hover:bg-dark-brandHover text-white"
              >
                Save Changes
              </button> */}
              <button
                onClick={handleUpdate}
                disabled={loading}
                className={`px-4 py-2 rounded-lg text-white flex items-center justify-center gap-2 ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-light-brand hover:bg-light-brandHover dark:bg-dark-brand dark:hover:bg-dark-brandHover"
                }`}
              >
                {loading && (
                  <AiOutlineLoading3Quarters className="animate-spin text-lg" />
                )}

                {loading ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Albums;
